import { createFileRoute } from '@tanstack/react-router';

import { automaticPixListSearch, bankAccountAutomaticPixScheduledScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Pagamentos agendados do Pix Automático (`router.tsx:549-556`), a aba Agendados.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/')({
  validateSearch: automaticPixListSearch,
  staticData: { screen: bankAccountAutomaticPixScheduledScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixScheduledScreen'),
});
